'use client'

import React from 'react'
import Image from 'next/image'
import { useLanguage } from '@/app/(frontend)/providers/LanguageProvider'
import { SlLocationPin } from 'react-icons/sl'
import Link from "next/link";

const ContactDetails = () => {
  const { language } = useLanguage()
  const isArabic = language === 'ar'

  return (
    <div className="text-[#414141]   text-sm flex flex-col gap-[36px] lg:w-[370px] xl:w-[400px] xl:h-[720px]">
      {isArabic ? (
        <>
          {/* Arabic Content */}
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col md:gap-0">
              <div className="flex items-center gap-[5px] xl:gap-[10px] h-[40px] md:mb-[5px]  mt-8 md:mt-0">
                {/* <img
                  src="/images/s2.png"
                  alt="map"
                  className="md:size-[20px] lg:size-[20px] xl:size-[20px] 2xl:size-[25px]"
                /> */}

                <SlLocationPin className="size-5 text-[#EE3E25]" />
                <h3 className="font-[500] xl:text-[16px] text-black">المكتب الرئيسي</h3>
              </div>

              <h2 className="font-[600] xl:text-[16px] mt-2">
                Container City for Storage and Maintenance (Container City®)
              </h2>
              <p className="font-[400] mt-1 xl:text-[15px] text-[#777777]">
               المنطقة: 95، الشارع: 617، المبنى: 54 <br />
                بو جود، قطر<br />
ص.ب: 8681              </p>
            </div>

            <div className=" space-y-5 xl:text-[16px]">
              <div className="flex items-start gap-2 text-[#575757]">
                <Image    src="/icons/mail.png" alt="Email Icon" width={18} height={14} />
                <a href="mailto:info@containercity.net" >
                  info@containercity.net{' '}
                  <span className="text-[#7F7F7F]"> (الاستفسارات العامة)</span>
                </a>
              </div>

              <div className="flex items-start gap-2 text-[#575757]">
                <Image    src="/icons/mail.png" alt="Email Icon" width={18} height={14} />
                <a href="mailto:info@containercity.net" >
                  info@containercity.net <span className="text-[#7F7F7F]"> (دعم العملاء)</span>
                </a>
              </div>

              <div className="flex items-start gap-2 text-[#575757]">
                <Image    src="/icons/mail.png" alt="Email Icon" width={18} height={14} />
                <a href="mailto:careers@containercity.net" >
                  careers@containercity.net <span className="text-[#7F7F7F]"> (الوظائف)</span>
                </a>
              </div>

              <div className="flex items-start gap-2 text-[#575757]">
                <Image    src="/icons/phone.png" alt="Phone Icon" width={16} height={16} />
                <a href="tel:+97455618135">
                  {' '}
                  <span dir="ltr">+974 5561 8135 </span>
                  <span className="text-[#7F7F7F]">(الخط الرئيسي)</span>
                </a>
              </div>

              <div className="flex items-start gap-2 text-[#575757]">
                <Image    src="/icons/phone.png" alt="Phone Icon" width={16} height={16} />
                <a href="tel:+97444702222" >
                  <span dir="ltr">+974 44702222</span>{' '}
                  <span className="text-[#7F7F7F]">(الخط الرئيسي)</span>
                </a>
              </div>
            </div>
          </div>

          <div className="flex flex-col xl:gap-[20px]   font-[400] xl:text-[15px] text-[#575757]">
            <div className="flex items-center md:gap-[10px] xl:text-[16px] h-[40px]">
              {/* <img
                src="/icons/chat.svg"
                alt="chat"
                className="md:size-[17px] lg:size-[20] xl:w-[20px] xl:h-[25px] 2xl:size-[25px]"
              /> */}

              <h3 className="font-[600] text-[#414141] xl:text-[16px]">ساعات العمل</h3>
            </div>
            <ul className=" ml-5 space-y-1">
              <li>الأحد إلى الخميس: 7:30 صباحًا - 6:00 مساءً</li>
              <li>السبت: 7:30 صباحًا - 1:30 مساءً</li>
              <li>الجمعة: مغلق</li>
            </ul>
          </div>

          <div className="flex flex-col xl:gap-[10px] font-[400] xl:text-[15px] text-[#575757]">
            <div className="flex items-center gap-[10px] xl:text-[16px] h-[40px]">
              <img
                src="/icons/chat.svg"
                alt="chat"
                className="size-[17px] md:size-[17px] lg:size-[20] xl:size-[16px] 2xl:size-[25px]"
              />
              <Link href="/get-a-quote">
  <h3 className="font-[500] text-black xl:text-[16px] hover:text-red-600 transition-colors">
    طلب عرض سعر أو استشارة
  </h3>
</Link>
            </div>
            <ul className="space-y-1">
              {[
                'تخزين ذاتي',
                'تأجير الحاويات',
                'تخزين في الساحات المفتوحة',
                'الصيانة والإصلاح',
                'التخزين الجمركي',
                'حلول النقل',
                'مكاتب / متاجر / سكن الموظفين',
              ].map((item) => (
                <li key={item} className="list-none xl:text-[15px]">
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-[10px] font-[400] xl:text-[15px] text-[#575757]">
            <div className="flex items-center gap-[10px] h-[40px]">
              <img
                src="/icons/mail-red.png"
                alt="chat"
                className="md:w-[18px] md:h-[16px] xl:w-[18px] xl:h-[16px]  2xl:size-[25px]"
              />
              <h3 className="font-[500] text-black xl:text-[16px]">
                أرسل لنا استفسارك أو طلب عرض سعر
              </h3>
            </div>
            <div className="space-y-1">
              <a href="mailto:sales@containercity.net" >sales@containercity.net</a>
              <p className="xl:text-[15px] text-[#777777]">
                أو استخدم النموذج للحصول على رد مخصص خلال 24 ساعة.
              </p>
            </div>
          </div>
        </>
      ) : (
        <>
          {/* English Content (Unchanged) */}
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col md:gap-0">
              <div className="flex items-center gap-[5px] xl:gap-[10px] h-[40px] md:mb-[5px]  mt-8 md:mt-0">
                {/* <img
                  src="/icons/map.png"
                  alt="map"
                  className="md:size-[20px] lg:size-[20] xl:size-[21px] 2xl:size-[25px]"
                /> */}
                <SlLocationPin className="size-5 text-[#EE3E25]" />
                <h3 className="font-[500] text-[15px] md:text-[14px]  xl:text-[16px] text-black">Head Office</h3>
              </div>

              <h2 className="font-[600] text-[15px] md:text-[14px] xl:text-[16px] mt-2">
                Container City for Storage and Maintenance W.L.L
              </h2>
              <p className="font-[400] mt-3 md:mt-1 text-[15px] md:text-[14px] xl:text-[15px] text-[#777777]">
                Zone:95, St:617, Building:54,  <br />
                Bu-Jood, Qatar, <br />
               P.O Box:8681
              </p>
            </div>

            <div className=" space-y-5 text-[15px] md:text-[14px] xl:text-[16px]">
              <div className="flex items-start gap-2 text-[#575757]">
                <Image    src="/icons/mail.png" alt="Email Icon" width={18} height={14} />
                <a href="mailto:info@containercity.net" >
                  info@containercity.net <span className="text-[#7F7F7F]">(General Inquiries)</span>
                </a>
              </div>

              <div className="flex items-start gap-2 text-[#575757]">
                <Image    src="/icons/mail.png" alt="Email Icon" width={18} height={14} />
                <a href="mailto:info@containercity.net" >
                  info@containercity.net <span className="text-[#7F7F7F]">(Customer Support)</span>
                </a>
              </div>

              <div className="flex items-start gap-2 text-[#575757]">
                <Image    src="/icons/mail.png" alt="Email Icon" width={18} height={14} />
                <a href="mailto:careers@containercity.net" >
                  careers@containercity.net <span className="text-[#7F7F7F]">(Careers)</span>
                </a>
              </div>

              <div className="flex items-start gap-2 text-[#575757]">
                <Image    src="/icons/phone.png" alt="Phone Icon" width={16} height={16} />
                <a href="tel:+97455618135" >
                  +974 5561 8135 <span className="text-[#7F7F7F]">(Main Line)</span>
                </a>
              </div>

              <div className="flex items-start gap-2 text-[#575757]">
                <Image    src="/icons/phone.png" alt="Phone Icon" width={16} height={16} />
                <a href="tel:+97444702222" >
                  +974 44702222<span className="text-[#7F7F7F]">(Main Line)</span>
                </a>
              </div>
              <div>
                <h2 className="font-[500] xl:text-[16px] mt-2">Working Hours:</h2>
                <p className="font-[400] mt-1 xl:text-[15px] text-[#777777]">
                  Sunday to Thursday: 7:30 AM - 6:00 PM
                </p>
                <p className="font-[400] mt-1 xl:text-[15px] text-[#777777]">
                  Saturday: 7:30 AM - 1:30 PM
                </p>
                <p className="font-[400] mt-1 xl:text-[15px] text-[#777777]">Friday: Closed</p>
              </div>
            </div>
          </div>

          {/* Request Quote */}
          <div className="flex flex-col xl:gap-[10px] font-[400] xl:text-[15px] text-[#575757]">
            <div className="flex items-center gap-[10px] xl:text-[16px] h-[40px]">
              <img
                src="/icons/chat-1.svg"
                alt="chat"
                className=" size-[17px] md:size-[17px] lg:size-[20] xl:size-[16px] 2xl:size-[25px]"
              />
              <Link href="/get-a-quote">
  <h3 className="font-[500] text-black text-[15px] md:text-[14px] xl:text-[16px] hover:text-red-600 transition-colors">
    Request a Quote or Consultation
  </h3>
</Link>
            </div>
            <ul className="space-y-1">
              {[
                'Self Storage',
                'Container Leasing',
                'Open Yard Storage',
                'Maintenance & Repair',
                'Bonded Warehousing',
                'Transportation Solutions',
                'Office / Retail / Staff Accommodation',
              ].map((item) => (
                <li key={item} className="list-none text-[15px] md:text-[14px] xl:text-[15px]">
                  {item}
                </li>
              ))}
            </ul>
          </div>

          {/* Inquiry */}
          <div className="flex flex-col gap-[10px]  font-[400] xl:text-[15px] text-[#575757]">
            <div className="flex items-center gap-[10px] h-[40px]">
              <img
                src="/icons/mail-red-1.svg"
                alt="chat"
                className="md:w-[18px] md:h-[16px] xl:w-[18px] xl:h-[16px]  2xl:size-[25px]"
              />
              <h3 className="font-[500] text-black text-[15px] md:text-[14px] xl:text-[16px]">Send us your Inquiry or RFQ</h3>
            </div>
            <div className="space-y-1 ">
              <a href="mailto:sales@containercity.net" className=" text-[15px] md:text-[14px] xl:text-[15px] ">sales@containercity.net</a>
              <p className=" text-[15px] md:text-[14px] xl:text-[15px] text-[#777777]">
                Or use the form for a tailored response within 24 hours.
              </p>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default ContactDetails
